import YardiMappingPage from "./YardiMappingPage";

export default YardiMappingPage;
